import { entityTypeToApiType } from 'helpers/mapEntityTypes';
import removeTrendOutliers from 'helpers/removeTrendOutliers';
import { getTrendOutlierRemovalConfig } from 'config';
import { EntityTypes } from 'context/entityContext';
import { IPeriodsEntityData } from './normalizePeriodsToDate';

/**
 * This updates the data array of a trend with after it has removed the outliers in the data
 * @param {Array} trends the trends data that needs to be cleaned up
 * @param {String} split the split to retreive the data key
 * @param {String} period the interval of the data
 * @returns {Array} the cleaned trend data
 */
function removeOutliersPerTrend(
  trends: IPeriodsEntityData[],
  split: EntityTypes,
  period: string,
  isChartDipsOn: boolean
): IPeriodsEntityData[] {
  // Do not remove outliers for yearly trend data
  if (period === 'year') {
    return trends;
  }

  const keyToCheck = split ? `${entityTypeToApiType(split)}_value` : 'value';

  return trends.map((trend: IPeriodsEntityData) => {
    const isChartDipsOnForThisTrend = isChartDipsOn;

    // for each trend remove the outliers
    const data = removeTrendOutliers({
      isChartDipsOn: isChartDipsOnForThisTrend,
      source: trend.data,
      keyToCheck,
      ...getTrendOutlierRemovalConfig(period),
    });

    return {
      ...trend,
      data,
    };
  });
}

export default removeOutliersPerTrend;
